/* ============================================================
 * PART 1 — Rise/Dawn PRODUCT media gallery (original, restored).
 * Defines the <media-gallery> custom element that swaps the main
 * product image when a thumbnail is clicked. Do NOT remove.
 * ============================================================ */
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ============================================================
 * PART 2 — Comic Bazooka STOREFRONT media gallery (homepage
 * "Media gallery" section: grid / carousel / stacked-deck /
 * lightbox / lazy videos). Shares this file to avoid a second
 * request. Independent from Part 1 above.
 * ============================================================ */
(function () {
  if (window.__mgInit) return;
  window.__mgInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Video play-on-view, but ONLY when front/active ---- */
  var videoIO = null;

  function videoBlocked(v) {
    var card = v.closest ? v.closest('.mg-deck__card') : null;
    if (card && !card.classList.contains('mg-deck__card--front')) return true;
    var tile = v.closest ? v.closest('.media-gallery__tile') : null;
    if (tile) {
      var grid = tile.closest('.media-gallery__grid');
      if (grid && (grid.scrollWidth - grid.clientWidth > 4) && !tile.classList.contains('is-active')) return true;
    }
    return false;
  }

  function applyVideo(v) {
    if (v.__mgInView && !videoBlocked(v)) {
      var p = v.play();
      if (p && p.then) {
        p.then(function () { v.setAttribute('data-mg-playing', ''); }).catch(function () {});
      } else {
        v.setAttribute('data-mg-playing', '');
      }
    } else {
      v.pause();
      v.removeAttribute('data-mg-playing');
    }
  }

  function refreshVideos(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var vids = root.querySelectorAll('video[data-mg-video]');
    Array.prototype.forEach.call(vids, applyVideo);
  }

  function setupVideos(scope) {
    var vids = scope.querySelectorAll('video[data-mg-video]');
    if (!vids.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, function (v) { v.setAttribute('controls', ''); });
      return;
    }
    if (!videoIO) {
      videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.__mgInView = e.isIntersecting && e.intersectionRatio > 0.5;
          applyVideo(e.target);
        });
      }, { threshold: [0, 0.5, 1] });
    }
    Array.prototype.forEach.call(vids, function (v) {
      if (!v.__mgObserved) { v.__mgObserved = true; videoIO.observe(v); }
    });
  }

  function setupCarousel(grid) {
    if (!grid || grid.__mgCarousel) return;
    grid.__mgCarousel = true;

    var tiles = grid.querySelectorAll('.media-gallery__tile');
    if (tiles.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'media-gallery__carousel-nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'media-gallery__arrow media-gallery__arrow--prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '&#8249;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'media-gallery__arrow media-gallery__arrow--next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '&#8250;';

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'media-gallery__dots';

    var dots = [];
    var active = 0;

    function tileCenter(t) { return t.offsetLeft + t.offsetWidth / 2; }
    function scrollToTile(i) {
      var t = tiles[i];
      if (!t) return;
      grid.scrollTo({ left: tileCenter(t) - grid.clientWidth / 2, behavior: 'smooth' });
    }

    Array.prototype.forEach.call(tiles, function (t, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'media-gallery__dot';
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.addEventListener('click', function () { stop(); scrollToTile(i); });
      dotsWrap.appendChild(d);
      dots.push(d);
    });

    nav.appendChild(prev);
    nav.appendChild(dotsWrap);
    nav.appendChild(next);
    grid.parentNode.insertBefore(nav, grid.nextSibling);

    function setActive(i) {
      if (i !== active) {
        if (tiles[active]) tiles[active].classList.remove('is-active');
        if (dots[active]) dots[active].classList.remove('is-active');
        active = i;
      }
      if (tiles[i]) tiles[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
      refreshVideos(grid);
    }

    function update() {
      var center = grid.scrollLeft + grid.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      Array.prototype.forEach.call(tiles, function (t, i) {
        var d = Math.abs(tileCenter(t) - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      setActive(best);
    }

    var raf = 0;
    grid.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });

    prev.addEventListener('click', function () { stop(); scrollToTile(Math.max(0, active - 1)); });
    next.addEventListener('click', function () { stop(); scrollToTile(Math.min(tiles.length - 1, active + 1)); });

    var auto = grid.getAttribute('data-mg-autoplay') === 'true';
    var speed = (parseInt(grid.getAttribute('data-mg-speed'), 10) || 5) * 1000;
    var timer = null;
    function canScroll() { return (grid.scrollWidth - grid.clientWidth) > 4; }
    function tick() {
      if (!canScroll()) return;
      var n = active + 1;
      if (n >= tiles.length) n = 0;
      scrollToTile(n);
    }
    function play() { if (!auto || reduce || timer) return; timer = setInterval(tick, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (auto && !reduce) {
      play();
      grid.addEventListener('mouseenter', stop);
      grid.addEventListener('mouseleave', play);
      grid.addEventListener('pointerdown', stop);
      grid.addEventListener('pointerup', play);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    }

    setActive(0);
  }

  /* ---- Stacked deck ---- */
  function layoutDeck(cards) {
    cards.forEach(function (card, i) {
      var ty = 0, sc = 1, rot = 0, op = 1, z = 100 - i;
      if (i === 1) { ty = -9; sc = 0.97; rot = 2; }
      else if (i === 2) { ty = -17; sc = 0.94; rot = -2; }
      else if (i >= 3) { ty = -17; sc = 0.94; op = 0; }
      card.style.transform = 'translateY(' + ty + 'px) scale(' + sc + ') rotate(' + rot + 'deg)';
      card.style.zIndex = String(z);
      card.style.opacity = String(op);
      card.classList.toggle('mg-deck__card--front', i === 0);
    });
  }

  function setupDeck(deck) {
    if (deck.__mgDeck) return;
    deck.__mgDeck = true;
    var cards = Array.prototype.slice.call(deck.querySelectorAll('.mg-deck__card'));
    if (!cards.length) return;
    deck.__cards = cards;
    layoutDeck(cards);
    refreshVideos(deck);

    if (!deck.hasAttribute('data-mg-deck') || cards.length < 2) return;

    var badge = deck.querySelector('[data-mg-count]');
    var total = cards.length;
    var shown = 1;
    var animating = false;
    deck.style.cursor = 'pointer';

    deck.addEventListener('click', function () {
      if (animating) return;
      animating = true;
      var front = deck.__cards[0];
      front.style.transition = 'transform .35s ease, opacity .35s ease';
      front.style.transform = 'translateY(-45px) scale(1) rotate(-7deg)';
      front.style.opacity = '0';
      setTimeout(function () {
        front.style.transition = 'none';
        deck.__cards.push(deck.__cards.shift());
        layoutDeck(deck.__cards);
        refreshVideos(deck);
        requestAnimationFrame(function () {
          deck.__cards.forEach(function (c) { c.style.transition = ''; });
        });
        shown = (shown % total) + 1;
        if (badge) badge.textContent = shown + ' / ' + total;
        animating = false;
      }, 330);
    });
  }

  /* ---- Tap-to-open lightbox ---- */
  var lbApi = null;
  function buildLightbox() {
    if (lbApi) return lbApi;
    var lb = document.createElement('div');
    lb.className = 'mg-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="mg-lightbox__close" aria-label="Close">&#215;</button>' +
      '<button type="button" class="mg-lightbox__arrow mg-lightbox__arrow--prev" aria-label="Previous">&#8249;</button>' +
      '<div class="mg-lightbox__track"></div>' +
      '<button type="button" class="mg-lightbox__arrow mg-lightbox__arrow--next" aria-label="Next">&#8250;</button>' +
      '<div class="mg-lightbox__footer"><div class="mg-lightbox__dots"></div><a class="mg-lightbox__shop" href="#">Shop</a></div>';
    document.body.appendChild(lb);

    var track = lb.querySelector('.mg-lightbox__track');
    var dotsWrap = lb.querySelector('.mg-lightbox__dots');
    var shop = lb.querySelector('.mg-lightbox__shop');
    var slides = [];
    var dots = [];

    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      track.innerHTML = '';
      dotsWrap.innerHTML = '';
      slides = [];
      dots = [];
    }
    function goTo(i) {
      if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function current() {
      var c = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bd = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft + s.offsetWidth / 2) - c);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function updateDots() {
      var a = current();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
    }

    lb.querySelector('.mg-lightbox__close').addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
    lb.querySelector('.mg-lightbox__arrow--prev').addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    lb.querySelector('.mg-lightbox__arrow--next').addEventListener('click', function () { goTo(Math.min(slides.length - 1, current() + 1)); });
    var raf = 0;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; updateDots(); }); }, { passive: true });

    lbApi = {
      open: function (images, link, label) {
        track.innerHTML = '';
        dotsWrap.innerHTML = '';
        slides = [];
        dots = [];
        images.forEach(function (src, i) {
          var slide = document.createElement('div');
          slide.className = 'mg-lightbox__slide';
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          slide.appendChild(img);
          track.appendChild(slide);
          slides.push(slide);
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'mg-lightbox__dot';
          d.setAttribute('aria-label', 'Photo ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
        if (link) { shop.href = link; shop.textContent = label || 'Shop'; shop.style.display = ''; }
        else { shop.style.display = 'none'; }
        lb.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        track.scrollLeft = 0;
        updateDots();
      }
    };
    return lbApi;
  }

  function bindLightbox() {
    if (window.__mgLbBound) return;
    window.__mgLbBound = true;
    function openFrom(tile) {
      var imgs = [];
      try { imgs = JSON.parse(tile.getAttribute('data-mg-images') || '[]'); } catch (err) {}
      if (!imgs.length) return;
      buildLightbox().open(imgs, tile.getAttribute('data-mg-link') || '', tile.getAttribute('data-mg-label') || 'Shop');
    }
    document.addEventListener('click', function (e) {
      var tile = e.target.closest ? e.target.closest('[data-mg-lightbox]') : null;
      if (!tile) return;
      e.preventDefault();
      openFrom(tile);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest ? e.target.closest('[data-mg-lightbox]') : null;
      if (!tile) return;
      e.preventDefault();
      openFrom(tile);
    });
  }

  function setup(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    setupVideos(root);
    var grids = root.querySelectorAll('.media-gallery__grid--carousel-mobile, .media-gallery__grid--carousel-desktop');
    Array.prototype.forEach.call(grids, setupCarousel);
    var decks = root.querySelectorAll('.mg-deck');
    Array.prototype.forEach.call(decks, setupDeck);
    bindLightbox();
  }

  if (document.readyState !== 'loading') {
    setup(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  }

  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
